export default {
  RECIPE_LOAD: 'RECIPE_LOAD',
  RECIPE_DELETE: 'RECIPE_DELETE',
  RECIPE_INGREDIENT: 'RECIPE_INGREDIENT',
  RECIPE_INGREDIENT_CHECK_INGREDIENT: 'RECIPE_INGREDIENT_CHECK_INGREDIENT',
  RECIPE_INGREDIENT_CHECK_SUBRECIPE: 'RECIPE_INGREDIENT_CHECK_SUBRECIPE',
  RECIPE_INGREDIENT_CHECK_ALL: 'RECIPE_INGREDIENT_CHECK_ALL',
  RECIPE_INGREDIENT_UNCHECK_ALL: 'RECIPE_INGREDIENT_UNCHECK_ALL',
  RECIPE_INGREDIENT_SERVINGS_UPDATE: 'RECIPE_INGREDIENT_SERVINGS_UPDATE',
  RECIPE_INGREDIENT_SERVINGS_RESET: 'RECIPE_INGREDIENT_SERVINGS_RESET',
  RECIPE_LIST_BLANK: 'RECIPE_LIST_BLANK',
  RECIPE_LIST_LOADING: 'RECIPE_LIST_LOADING',
  RECIPE_LIST_COMPLETE: 'RECIPE_LIST_COMPLETE',
  RECIPE_LIST_ERROR: 'RECIPE_LIST_ERROR',
};


// WEBPACK FOOTER //
// ./modules/recipe/constants/RecipeConstants.js